import React, { useEffect, useState, useRef } from 'react';
import { HelpCircle } from 'lucide-react';
interface InfoTooltipProps {
  text: string;
}
export function InfoTooltip({
  text
}: InfoTooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!isVisible || !tooltipRef.current || !triggerRef.current) return;
    const tooltip = tooltipRef.current;
    const trigger = triggerRef.current;
    const triggerRect = trigger.getBoundingClientRect();
    const tooltipRect = tooltip.getBoundingClientRect();
    // If tooltip goes off the right edge, shift it left
    if (triggerRect.left + tooltipRect.width > window.innerWidth - 16) {
      tooltip.style.left = 'auto';
      tooltip.style.right = '0';
    }
  }, [isVisible]);
  return <span className="relative inline-flex ml-1" data-id="element-1341">
      <button ref={triggerRef} type="button" className="text-slate-400 hover:text-slate-600 transition-colors focus:outline-none" onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} onClick={e => {
      e.preventDefault();
      setIsVisible(!isVisible);
    }} aria-label="More information" data-id="element-1342">
        <HelpCircle className="w-3.5 h-3.5" data-id="element-1343" />
      </button>
      {isVisible && <div ref={tooltipRef} className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 px-3 py-2.5 text-xs leading-relaxed text-slate-700 bg-white border border-slate-200 rounded-lg shadow-lg pointer-events-none" data-id="element-1344">
          {text}
          <div className="absolute top-full left-1/2 -translate-x-1/2 -mt-px" data-id="element-1345">
            <div className="w-2 h-2 bg-white border-r border-b border-slate-200 transform rotate-45 -translate-y-1" data-id="element-1346" />
          </div>
        </div>}
    </span>;
}